export const getEmailPattern = (message: string) => ({
  value: /\S+@\S+\.\S+/,
  message,
});
